import React from "react";
import { FaTimes } from "react-icons/fa";

const SlidingDiv = ({ isOpen, onClose, title, children, className }) => {
  if (!isOpen) return null;

  return (
    <div
      className={`bg-white fixed top-0 right-0 h-full w-3/4 overflow-hidden shadow-lg ${className}`}
    >
      <FaTimes
        onClick={onClose}
        className="p-1 m-1 text-2xl text-red-500 float-right cursor-pointer"
      />
      <h3 className="m-2 font-semibold text-lg">{title}</h3>
      <hr />
      <div className="h-[90vh] overflow-auto" id="form">{children}</div>
    </div>
  );
};

export default SlidingDiv;
